import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
    },
});

const Bewerbungen: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <h1>Bewerbungen</h1>
            <p>Bewerbungsverwaltung und Übersicht</p>
        </div>
    );
};

export default Bewerbungen;
